<p-autoComplete
  #autocomplete
  [dropdown]="true"
  [showClear]="true"
  [multiple]="multiple"
  [forceSelection]="forceSelection"
  [delay]="500"
  [(ngModel)]="selected"
  [suggestions]="suggestions"
  [optionLabel]="getItemLabelProperty()"
  (completeMethod)="onLazyLoad($event)"
  (onSelect)="onSelect(autocomplete)"
  (onClear)="onClear($event)"
  (ngModelChange)="handleChange($event)"
  (blur)="onTouched()"
  [disabled]="disabled"
  [placeholder]="placeholder"
  class="w-full"
  appendTo="body"
/>
